interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`mb-8 md:mb-10 ${isCenter ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-4 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}